var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5429 39H19.4571C8.72855 39 0 30.2714 0 19.5429V19.4571C0 8.72855 8.72855 0 19.4571 0H19.5429C30.2714 0 39 8.72855 39 19.4571V19.5429C39 30.2714 30.2714 39 19.5429 39ZM19.4571 1.32011C9.45593 1.32011 1.32011 9.45593 1.32011 19.4571V19.5429C1.32011 29.544 9.45593 37.6799 19.4571 37.6799H19.5429C29.5441 37.6799 37.6799 29.544 37.6799 19.5429V19.4571C37.6799 9.45593 29.5441 1.32011 19.5429 1.32011H19.4571Z",
    fill: "url(#paint0_linear_862_3414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.79648 18.856C7.84928 18.8296 7.90211 18.8045 7.95359 18.7807C8.84863 18.3662 9.75555 17.9781 10.6611 17.59C10.71 17.59 10.7918 17.5333 10.838 17.5148C10.908 17.4844 10.978 17.4554 11.0479 17.425C11.1826 17.3669 11.3172 17.3102 11.4506 17.2521C11.7199 17.1372 11.9878 17.0224 12.2571 16.9075C12.7944 16.6778 13.3317 16.4481 13.869 16.2171C14.9436 15.7577 16.0195 15.297 17.094 14.8376C18.1686 14.3782 19.2445 13.9175 20.3191 13.4581C21.3936 12.9987 22.4695 12.538 23.5441 12.0786C24.6186 11.6192 25.6946 11.1584 26.7691 10.699C27.0081 10.5961 27.2668 10.4429 27.5229 10.398C27.7381 10.3598 27.948 10.2858 28.1645 10.2449C28.575 10.167 29.0278 10.1353 29.4212 10.3056C29.5572 10.365 29.6826 10.4482 29.7869 10.5525C30.2859 11.0462 30.2159 11.8568 30.1103 12.5511C29.375 17.3907 28.6397 22.2315 27.9031 27.071C27.8028 27.735 27.6655 28.4637 27.1414 28.8835C26.6978 29.2387 26.0668 29.2783 25.519 29.1278C24.9711 28.976 24.488 28.6578 24.014 28.345C22.0484 27.0433 20.0814 25.7417 18.1158 24.4401C17.6485 24.1312 17.1284 23.7272 17.1336 23.1662C17.1363 22.8282 17.3382 22.5272 17.5442 22.2592C19.2524 20.0309 21.717 18.4996 23.5507 16.3742C23.8094 16.0745 24.0127 15.5333 23.6576 15.3603C23.4464 15.2574 23.2035 15.3973 23.0107 15.5306C20.587 17.2138 18.1646 18.8982 15.7409 20.5814C14.9502 21.1305 14.1211 21.6956 13.168 21.8302C12.3152 21.9517 11.4572 21.714 10.6321 21.4711C9.94036 21.2678 9.24992 21.0593 8.56215 20.8441C8.19648 20.7306 7.81892 20.6078 7.53642 20.3504C7.25391 20.0929 7.09156 19.6599 7.26186 19.3167C7.36879 19.1015 7.57605 18.9656 7.79387 18.8547L7.79648 18.856Z",
    fill: "url(#paint1_linear_862_3414)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_3414",
    x1: 19.5,
    y1: 0,
    x2: 19.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_862_3414",
    x1: 18.6892,
    y1: 10.1819,
    x2: 18.6892,
    y2: 29.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#7C5F28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B555"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.2d1c4fcc878801ac4ad4b796878d1971.svg";
export { ForwardRef as ReactComponent };